import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const TriangleCross = ({
  color = 'foraBlue',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg
      width={Number(width)}
      height={Number(width)}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5866 19.9995H2.74657C1.92657 19.9995 1.40657 19.1295 1.80657 18.4195L10.7266 2.54945C11.1366 1.81945 12.1966 1.81945 12.6066 2.54945L21.5266 18.4195C21.9266 19.1295 21.4066 19.9995 20.5866 19.9995ZM19.6467 18.7396H3.68665C3.28665 18.7396 3.03665 18.3096 3.23665 17.9696L11.2167 3.99956C11.4166 3.64956 11.9267 3.64956 12.1266 3.99956L20.1067 17.9596C20.3067 18.3096 20.0567 18.7296 19.6567 18.7296L19.6467 18.7396ZM9.05472 11.216C9.34324 10.9275 9.81102 10.9275 10.0995 11.216L11.6668 12.7833L13.234 11.2162C13.5225 10.9277 13.9903 10.9277 14.2788 11.2162C14.5673 11.5047 14.5673 11.9725 14.2788 12.261L12.7117 13.8281L14.2788 15.3953C14.5674 15.6839 14.5674 16.1516 14.2788 16.4402C13.9903 16.7287 13.5225 16.7287 13.234 16.4402L11.6668 14.873L10.0995 16.4403C9.81095 16.7288 9.34317 16.7288 9.05465 16.4403C8.76613 16.1518 8.76613 15.684 9.05465 15.3955L10.622 13.8281L9.05472 12.2609C8.7662 11.9723 8.7662 11.5045 9.05472 11.216Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
